import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { theme } from 'config/theme';

type StatusChipProps = {
  label: string;
  color?: string;
};

function StatusChip({ label, color }: StatusChipProps) {
  return <StyledStatusChip color={color}>{label}</StyledStatusChip>;
}

const StyledStatusChip = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>(({ color }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
  borderRadius: theme.shape.borderRadius,
  fontWeight: 600,
  fontSize: 13,
  backgroundColor: color || theme.palette.custom.dairyCream,
  color: theme.palette.custom.tuna,
  whiteSpace: 'nowrap',
}));

export default StatusChip;
